declare module '@mui/material/styles' {
	interface Palette {
		navbar: {
			primary: {
				main: string;
				active: string;
			};
			secondary: {
				main: string;
				active: string;
			};
		};
	}
	interface PaletteOptions {
		navbar?: {
			primary?: {
				main?: string;
				active?: string;
			};
			secondary?: {
				main?: string;
				active?: string;
			};
		};
	}
}

export const palette = {
	background: {
		default: '#282424',
		paper: '#1B1919',
	},
	primary: {
		main: '#FD9800',
		light: '#EAF0F1',
	},
	secondary: {
		main: '#949EC2',
	},
	navbar: {
		primary: {
			main: '#ffffff',
			active: '#FD9800',
		},
		secondary: {
			main: '#ffffff',
			active: '#FD9800',
		},
	},
	text: {
		primary: '#ffffff',
		secondary: '#A3A3A3',
		disabled: '#3e3939'
	}
};